import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, Search } from "lucide-react";
import { designUrl } from "../data/catalog";
import { useCatalog } from "../context/CatalogContext";

export default function SearchOverlay({ open, onClose }) {
  const [q, setQ] = useState("");
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const { searchDesignsMerged } = useCatalog();

  useEffect(() => {
    if (!open) return undefined;
    setQ("");
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => inputRef.current && inputRef.current.focus(), 60);
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  const results = useMemo(() => (q.trim().length >= 2 ? searchDesignsMerged(q, 40) : []), [q, searchDesignsMerged]);

  if (!open) return null;

  const suggestions = ["Gold Rings", "Diamond Rings", "Silver Murti", "Temple Jewellery", "Rose Gold", "Bangles", "Necklaces"];

  const goTo = (d) => {
    onClose();
    navigate(designUrl(d));
  };

  return (
    <div
      className="so-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Search designs"
    >
      <div className="so-inner" onClick={(e) => e.stopPropagation()}>
        <div className="so-bar">
          <Search size={20} />
          <input
            ref={inputRef}
            type="text"
            placeholder="Search designs, categories or styles…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <button type="button" className="so-close" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        {q.trim().length < 2 && (
          <div className="so-suggest">
            <span className="so-hint">Try searching:</span>
            {suggestions.map((s) => (
              <button key={s} type="button" onClick={() => setQ(s)}>
                {s}
              </button>
            ))}
          </div>
        )}

        {q.trim().length >= 2 && (
          <div className="so-results">
            <div className="so-count">
              {results.length === 0
                ? "No designs matched your search."
                : `${results.length}+ designs matched`}
            </div>
            <div className="so-grid">
              {results.map((d) => (
                <button
                  key={d.id}
                  type="button"
                  className="so-item"
                  onClick={() => goTo(d)}
                >
                  <img src={d.image} alt={d.name} loading="lazy" />
                  <div>
                    <span className="so-item-cat">
                      {d.category.label} · {d.subCategory.label}
                    </span>
                    <p>
                      {d.styleName} {d.number}
                    </p>
                    <span className="so-item-meta">
                      {d.purity} · {d.weight}{d.weightUnit}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
